import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Item from './Item';

const EventList = ({ content, showType, allFold, changeAllFold = () => {} }) => {
    const { nodes, parties, timeline } = content;

    // 记录所有短内容收起展开状态的数组
    const [nodeFoldList, setNodeFoldList] = useState([]);

    // 根据单个短内容收起展开状态改变nodeFoldList和allFold
    const changeFold = (id, bool) => {
        // 获取nodeFoldList的当前项并改变值
        const newNodeFoldList = nodeFoldList.map(item => ({ id: item.id, fold: item.id === id ? bool : item.fold }));

        // 判断现在的全部收起展开状态
        const allNodeFold = !newNodeFoldList.find(item => item.fold === false);
        const allNodeUnfold = !newNodeFoldList.find(item => item.fold === true);
        let newAllFold = allFold;

        if (allNodeFold) {
            newAllFold = true;
        }

        if (allNodeUnfold) {
            newAllFold = false;
        }

        // 改变nodeFoldList和allFold
        setNodeFoldList(newNodeFoldList);
        changeAllFold(newAllFold);
    };

    useEffect(
        () => {
            const newNodeFoldList = nodes.map(item => {
                const { id } = item;
                const nodeFold = nodeFoldList.find(item => item.id === id);
                const fold = nodeFold ? nodeFold.fold : allFold;

                return { id, fold };
            });

            setNodeFoldList(newNodeFoldList);
        },
        [nodes],
    );

    useEffect(
        () => {
            const newNodeFoldList = nodeFoldList.map(item => ({ id: item.id, fold: allFold }));

            setNodeFoldList(newNodeFoldList);
        },
        [allFold],
    );

    return (
        <div>
            {nodes && Array.isArray(nodes) && nodes.length
                ? nodes.map((item, index) => (
                      <Item
                          key={item.id}
                          content={item}
                          showType={showType}
                          allFold={allFold}
                          parties={parties}
                          timeline={timeline}
                          changeFold={changeFold}
                          index={index}
                      />
                  ))
                : null}
        </div>
    );
};

EventList.propTypes = {
    content: PropTypes.object,
    showType: PropTypes.string,
    allFold: PropTypes.bool,
    changeAllFold: PropTypes.func,
};

export default errorBoundary(EventList);
